import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function siteManagementReducer(state = initialState.siteManagement, action) {
  switch (action.type) {
    case types.GET_SITE_MANAGEMENT_SUCCESS:
      return action.siteManagement;
    case types.CLEAR_SITE_MANAGEMENT:
      return initialState.siteManagement;
    default:
      return state;
  }
}
